export const commissionBillImportEndpoints = (builder) => ({
    // Process Commission Bill PDF and extract JSON data
    processCommissionBillPdf: builder.mutation({
        query: (formData) => ({
            url: '/commission-bill-import/process-commission-bill',
            method: 'POST',
            body: formData,
        }),
    }),

    // Import Commission Bill JSON data into database
    importCommissionBillJson: builder.mutation({
        query: (jsonData) => ({
            url: '/commission-bill-import/save-commission-data',
            method: 'POST',
            body: jsonData,
        }),
        invalidatesTags: ['CommissionReceipt'],
    }),
});
